module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAAAXNSR0IArs4c6QAAATRJREFUWEft1r0NgkAYxvHn1MYoCSM4go5gYbB0BDZwBZ3EFaxMtNENZARHoNDKmFfFj3BwH3C8xEKsSEz8/zjvXhD48Uf8uI8G0KzAf6wAecEKRCdx3i2zp672FXjFEb7CtMgiagXI8c+9y4jaAOp4HlELwBxPEJE4b0fPC3ZAkTg63bGI1zE7oGycFeASZwO4xrUA8qcDXFu+uGwi2+O6SlwJSOI32oPgg9pjE6JqPAdIxQfvO491CI64BFDEP6ufQ3DFZUA/OAIYav7zL4IzLgN6kyFEaw/A1yKAw2OKzQwbM0oPGdsGzu8BO8L0m6Xj6lPghnCK6+dAOYRz3DgJqRiiUtw6ii2IynErIHmJUq8ES7wQIEF40xBEq/cRYIsXBqQQ87Ln3DYL2N+IbMHs9w3gDlX5xSLJU5mAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/red-check.png
// module id = k84k
// module chunks = 1